import { NodeAccessApproval, NodeAccessProfileStatus } from '@prisma/client';
import { DescriptionsItemType } from 'antd/es/descriptions';

import { formatIsoDate } from '@app/utils-agnostic';

import { ProfileOperationRenderer, ProfileStatusRenderer } from '../../profiles';

export const getDescriptionItems = (record: NodeAccessApproval): DescriptionsItemType[] => [
  { key: 'Operation', children: <ProfileOperationRenderer operation={record.operation} />, label: 'Operation' },
  { key: 'CW User', children: record.name, label: 'CW User' },
  { key: 'CW Job Title', children: record.jobRole, label: 'CW Job Title' },
  { key: 'Email', children: record.email, label: 'Email' },
  { key: 'Project', children: record.dieName, label: 'Project' },
  { key: 'Node', children: record.nodeName, label: 'Node' },
  { key: 'Contract Name', children: record.contractName, label: 'Contract Name' },
  { key: 'Contract Number', children: record.contractNumber, label: 'Contract Number' },
  { key: 'Intel Signed Date', children: formatIsoDate(record.intelSignedDate), label: 'Intel Signed Date' },
  { key: 'Status', children: <ProfileStatusRenderer status={record.status} />, label: 'Status' },
  ...(record.status === NodeAccessProfileStatus.REJECTED
    ? [
        {
          key: 'Justification',
          children: record.justification,
          label: 'Justification',
        },
      ]
    : []),
];
